import { render, staticRenderFns } from "./Duration.vue?vue&type=template&id=e3455232&scoped=true&"
import script from "./Duration.vue?vue&type=script&lang=ts&"
export * from "./Duration.vue?vue&type=script&lang=ts&"
import style0 from "./Duration.vue?vue&type=style&index=0&id=e3455232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3455232",
  null
  
)

export default component.exports